import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeletePortalNatureOfBusiness = () => {
  const { authHeader } = useAuth();
  return useMutation(({ id }: { id: number }) => {
    return axios.delete(
      `${env.verifyServiceUrl}individual/portal_nature_of_business/${id}/`,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
